// src/features/frighi/useCryoHistory.js
import { useEffect, useState } from "react";
import { getCryoHistory } from "./api";

export function useCryoHistory(mac, { days = 1 } = {}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let stop = false;

    async function load() {
      try {
        setLoading(true);
        setError(null);

        const j = await getCryoHistory({ mac, days });
        const arr = j.items || j.data || [];

        const rows = arr
          .map((r) => {
            const tRaw =
              r.rilevata_il ??
              r.timestamp ??
              r.t ??
              null;

            // 🔑 FIX FONDAMENTALE
            const t =
              typeof tRaw === "string"
                ? tRaw.replace(" ", "T")
                : tRaw;

            const yRaw =
              r.temperatura ??
              r.valore ??
              r.y ??
              null;

            return {
              t: t ? new Date(t) : null,
              y: yRaw != null ? parseFloat(yRaw) : null,
              alert: Number(r.alert ?? 0),
            };
          })
          .filter(
            (p) =>
              p.t instanceof Date &&
              !isNaN(p.t) &&
              Number.isFinite(p.y)
          );

        if (!stop) setData(rows);
      } catch (e) {
        if (!stop) setError(e.message || String(e));
      } finally {
        if (!stop) setLoading(false);
      }
    }

    if (mac) load();
    return () => {
      stop = true;
    };
  }, [mac, days]);

  return { data, loading, error };
}
